import React from 'react';

export default React.lazy(() => import('./asset-config'));
